import { render, staticRenderFns } from "./ambufTransfer.vue?vue&type=template&id=48c88ba0"
import script from "./ambufTransfer.vue?vue&type=script&lang=js"
export * from "./ambufTransfer.vue?vue&type=script&lang=js"
import style0 from "./ambufTransfer.vue?vue&type=style&index=0&id=48c88ba0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports